import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { ConfigurationService } from '@shared/services/configuration.service';

@Directive({
  selector: '[appIsFeatureFlagEnabled]',
})
export class IsFeatureFlagEnabledDirective {
  @Input('appIsFeatureFlagEnabled')
  set feature(feature: string) {
    this.checkFeatureFlag(feature);
  }

  constructor(
    private viewContainer: ViewContainerRef,
    private template: TemplateRef<any>,
    private configurationService: ConfigurationService,
  ) {}

  private checkFeatureFlag(feature: string): void {
    const flag = this.configurationService.configuration.features[feature];
    if (flag === undefined || flag) {
      this.viewContainer.createEmbeddedView(this.template);
    } else {
      this.viewContainer.clear();
    }
  }
}
